<template>
  <div>
    <div class='ctitle'>
    <h2>正式题目列表</h2>
    </div>
    <problem-search ref="s" @search="getPagedProblem"></problem-search>
    <problem-table :tableData="problemList" ></problem-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageIndexChange"
      :current-page="pageIndex"
      :page-sizes="[20, 30, 40, 50]"
      :page-size="rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import problemSearch from '@/components/search/problemSearch'
  import problemTable from '@/components/problemTable/problemTable'

  export default {
    data () {
      return {
        problemMain: '0',
        problemGuid: '',
        keywords: '',
        title: '',
        qt: ''
      }
    },
    computed: {
      ...mapGetters([
        'problemList',
        'pageIndex',
        'rows',
        'total'
      ])
    },
    created () {
      // this.$store.dispatch('actions_getProblemList')
    },
    components: {
      problemTable,
      problemSearch
    },
    mounted () {
      this.getPagedProblem({})
    },
    methods: {
      getPagedProblem ({problemMain = this.problemMain, problemGuid = this.problemGuid, keywords = this.keywords, title = this.title, qt = this.qt}) {
        this.problemMain = problemMain
        this.problemGuid = problemGuid
        this.keywords = keywords
        this.title = title
        this.qt = qt
        let getTotal = this.$store.dispatch('actions_getProblemTotal', [problemMain, problemGuid, keywords, title, qt])
        let getList = this.$store.dispatch('actions_getProblemList', [problemMain, problemGuid, keywords, title, qt, this.pageIndex, this.rows])
        Promise.all([getTotal, getList]).then((values) => {
          this.loading = false
        }).catch((errs) => {
          this.loading = false
          console.log(errs)
        })
      },
      pageSizeChange (ps) {
        this.$store.commit('SET_ROWS', ps)
        this.getPagedProblem({})
      },
      pageIndexChange (pi) {
        this.$store.commit('SET_PAGE_INDEX', pi)
        this.getPagedProblem({})
      }
    }
  }
</script>

<style  scoped>
  .ctitle{
    height: 56px;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// problemList.vue?2d4baecc